import React from 'react'
import styled from 'styled-components'

const Styling = styled.div`
margin-bottom:4rem;

    .image-wrapper{
    //border:1rem solid var(--white);
    background:var(--white);
    padding-bottom: 50%;
    position: relative;
    display: inline-flex;
    width:100%;
    margin-bottom: 2rem;

        &:last-of-type{
            margin-bottom: 0;
        }

        @media only screen and (min-width: 2000px) {
        width:calc(50% - 2rem);
        padding-bottom: 25%;
        margin-bottom: 0;

            &:first-child{
            margin-right:4rem;
            }
        }




        .gatsby-image-wrapper{
        position: absolute;
        top:0;
        left:0;
        width:100%;
        height:100%;
        }

    }
`

export { Styling }